module.exports = __webpack_public_path__ + "media/images/survey-completed-4fc3a606fcb711cb56df36a4ae9c7a41.svg";